import { render, staticRenderFns } from "./BaseFormItem.vue?vue&type=template&id=5be99e68&scoped=true&"
import script from "./BaseFormItem.vue?vue&type=script&lang=js&"
export * from "./BaseFormItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormItem.vue?vue&type=style&index=0&id=5be99e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be99e68",
  null
  
)

export default component.exports